// extracted by mini-css-extract-plugin
module.exports = {"list":"RadioGroup_list__22LIA","listItem":"RadioGroup_listItem__1pBbc"};